import Button from "Components/shared/button";
import FormControl from "Components/shared/control";
import Select, { CustomSelect } from "Components/shared/select";
import Text from "Components/shared/text";
import React, { useEffect, useState, useLayoutEffect } from "react";
import Back from "./Back";
import styles from "./registeration.module.css";

const StageTwo = ({ onNext, onPrev, values, errors, touched, handleChange, handleUpdate }) => {
  const [countries, setCountries] = useState([])
  useEffect(() => {

    const getCountries = async() => {
      const resp = await fetch("https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/index.json");
      const json = await resp.json();
      if(json.length){
        
        setCountries(json);
      }
    }
    getCountries()
    
  },[])
 
  return (
    <div className={styles.StageTwo}>
      <Back onClick={onPrev} />
      <Text
        className={styles.Text}
        variant="xl"
        color="primary"
        style={{ width: "400px" }}
      >
        Let us know your country of residence
      </Text>
      <FormControl
        fullWidth
        label="Select your country"
        style={{ marginTop: "25px" }}
        name="country"
        id="country"
      >
        <CustomSelect options={countries} 
        
        {...handleUpdate()}
        value={values.country}
        placeholder="Select country" fullWidth
        optionsValue={(option) => (option.code)} minWidth="438px"
        optionsText={(option) => (<span className="row-start" style={{gap:"12px"}}>
          {option?.image ? <img src={`${option.image}`} alt={`${option?.name} flag`} width="32px" height="24px" />: option?.emoji}
          <span>{option?.name || option}</span>
        </span>)}
        
         />
      </FormControl>
      <FormControl fullWidth>
        <Button label="Continue" onClick={onNext} fullWidth
        disabled={!(values.country)} />
      </FormControl>
    </div>
  );
};

export default StageTwo;
